// extracted by mini-css-extract-plugin
export default {"container":"cartContainer_container__8bl3R"};